module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-dialog', {
    attrs: {
      "visible": _vm.inner_visible,
      "title": _vm.title,
      "before-close": _vm.before_close
    },
    on: {
      "update:visible": function($event) {
        _vm.inner_visible = $event
      }
    }
  }, [_vm._t("default"), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_vm._t("footer", [_c('div', {
    staticClass: "ui button",
    on: {
      "click": function($event) {
        _vm.cancel()
      }
    }
  }, [_vm._v("取消")])])], 2)], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6769c7ce","hasScoped":false}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./client/src/components/basic/PromiseDialog.vue
// module id = 317
// module chunks = 0